module.exports = __webpack_public_path__ + "static/kinoklubb-black.a08764c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/assets/img/kinoklubb-black.png
// module id = 531
// module chunks = 231608221292675